import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useLoading } from '../contexts/LoadingContext';

export const useNavigationLoading = () => {
  const location = useLocation();
  const { showLoading, hideLoading } = useLoading();
  const isInitialLoad = useRef(true);

  useEffect(() => {
    // Skip loading on initial page load
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }

    // Disable loading overlay for all pages - no more blurry loading text
    // This provides a cleaner, faster user experience
    return;
  }, [location.pathname, showLoading, hideLoading]);

  return { showLoading, hideLoading };
};
